import { Route, Routes } from "react-router-dom";
import BackofficeLayout from "./layouts/BackofficeLayout";
import CatalogPage from "./pages/CatalogPage";
import PosLayout from "./layouts/PosLayout";
import DashboardPage from "./pages/DashboardPage";
import ErrorPage from "./pages/ErrorPage";
import LoginPage from "./pages/LoginPage";
import PosPage from "./pages/PosPage";
import ReportsPage from "./pages/ReportsPage";
import ResourcePage from "./pages/ResourcePage";
import SalesPage from "./pages/SalesPage";
import TeamPage from "./pages/TeamPage";
import UsersPage from "./pages/UsersPage";
import AttendancePage from "./pages/AttendancePage";
import AppointmentsPage from "./pages/AppointmentsPage";
import ClientsPage from "./pages/ClientsPage";
import PayrollPage from "./pages/PayrollPage";
import PaymentMethodsPage from "./pages/PaymentMethodsPage";
import PaymentFeesPage from "./pages/PaymentFeesPage";
import CashRegisterPage from "./pages/CashRegisterPage";
import BrandingPage from "./pages/BrandingPage";
import ExpensesPage from "./pages/ExpensesPage";
import { ProtectedRoute, RoleProtectedRoute } from "./routes/ProtectedRoute";
import HomeRedirect from "./routes/HomeRedirect";
import { BACKOFFICE_ROLES, POS_ROLES } from "./utils/permissions";

export default function App() {
  return <Routes>
    <Route path="/" element={<HomeRedirect />} />
    <Route path="/login" element={<LoginPage />} />
    <Route path="/pos" element={<ProtectedRoute><RoleProtectedRoute roles={POS_ROLES}><PosLayout /></RoleProtectedRoute></ProtectedRoute>}><Route index element={<PosPage />} /></Route>
    <Route path="/backoffice" element={<ProtectedRoute><RoleProtectedRoute roles={BACKOFFICE_ROLES}><BackofficeLayout /></RoleProtectedRoute></ProtectedRoute>}>
      <Route index element={<DashboardPage />} />
      <Route path="dashboard" element={<DashboardPage />} />
      <Route path="catalogo" element={<CatalogPage />} />
      <Route path="equipo" element={<TeamPage />} />
      <Route path="ventas" element={<SalesPage />} />
      <Route path="reportes" element={<ReportsPage />} />
      <Route path="pagos-personal" element={<RoleProtectedRoute roles={["administrador"]}><PayrollPage /></RoleProtectedRoute>} />
      <Route path="metodos-pago" element={<RoleProtectedRoute roles={["administrador"]}><PaymentMethodsPage /></RoleProtectedRoute>} />
      <Route path="caja" element={<RoleProtectedRoute roles={["administrador"]}><CashRegisterPage /></RoleProtectedRoute>} />
      <Route path="branding" element={<BrandingPage />} />
      <Route path="gastos" element={<RoleProtectedRoute roles={["administrador"]}><ExpensesPage /></RoleProtectedRoute>} />
      <Route path="intereses-pago" element={<RoleProtectedRoute roles={["administrador"]}><PaymentFeesPage /></RoleProtectedRoute>} />
      <Route path="turnos" element={<AppointmentsPage />} />
      <Route path="asistencia" element={<AttendancePage />} />
      <Route path="clientes" element={<ClientsPage />} />
      <Route path="barberos" element={<ResourcePage resource="barberos" />} />
      <Route path="servicios" element={<ResourcePage resource="servicios" />} />
      <Route path="usuarios" element={<UsersPage />} />
    </Route>
    <Route path="*" element={<ErrorPage />} />
  </Routes>;
}









